import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ImageTile from 'Compass/profile-lab/components/ImageTile';
import { db } from 'Compass/profile-lab/services/db';
import { usePhotoWithStatus } from 'Compass/profile-lab/hooks/usePhotoWithStatus';
import { fisherYatesShuffle } from 'Compass/profile-lab/utils/assetFormatting';
import { fetchSignedUrlsForCurrentUser } from 'Compass/profile-lab/hooks/useSignedUrls';
import { ErrorMessage, LoadingMessage } from 'Compass/profile-lab/styles/common';

const ProfileLabSamplePage: React.FC = () => {
  const location = useLocation();
  const [signedUrls, setSignedUrls] = useState<Record<number, string>>({});

  const { photos: allPhotos, loading, error } = usePhotoWithStatus(
    async () => {
      const allPhotos = await db.getAllPhotos();
      const shuffled = fisherYatesShuffle(allPhotos);
      return shuffled.slice(0, 50);
    },
    [location.key]
  );

  const assets = useMemo(() => allPhotos, [allPhotos]);

  useEffect(() => {
    const loadSignedUrls = async () => {
      if (assets.length === 0) return;

      const photoLids = assets.map(a => a.photo_lid);
      const urls = await fetchSignedUrlsForCurrentUser(photoLids);
      setSignedUrls(urls);
    };

    void loadSignedUrls();
  }, [assets]);

  if (loading) {
    return <LoadingMessage>Loading...</LoadingMessage>;
  }

  if (error) {
    return <ErrorMessage>Error loading sample: {error}</ErrorMessage>;
  }

  return (
    <>
      {assets.map((asset) => (
        <ImageTile key={asset.photo_lid} asset={asset} imageUrl={signedUrls[asset.photo_lid]} />
      ))}
    </>
  );
};

export default ProfileLabSamplePage;
